module.exports = __webpack_public_path__ + "img/EmptyState2.160c213d.png";